import { useWeatherLayers } from "./useWeatherLayers"

export const useWeatherOverviewLayers = (enabled: boolean) => {
    const layers = useWeatherLayers("overview")
    if (!enabled) return []
    return layers.sort((a, b) => a.zIndex - b.zIndex).map((l) => l.layer)
}
